import React, { PropsWithChildren, useState } from 'react';
import { grey } from '@mui/material/colors';
import { Add, Remove } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { Box, IconButton, Typography } from '@mui/material';
import { SectionStatus } from '../../../../types';

interface Props {
  label: string;
  sectionKey: keyof SectionStatus;
}

export const SummaryContainer = ({ children, sectionKey, label }: PropsWithChildren<Props>) => {
  const classes = useStyles();

  const [sectionStatus, setSectionStatus] = useState<SectionStatus>({
    docs: true,
    details: true,
    criteria: true,
    structure: true,
    submissionSettings: true,
    insuranceCoverage: true,
  });

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <IconButton
          size="small"
          onClick={() =>
            setSectionStatus(prev => ({
              ...prev,
              [sectionKey]: !prev[sectionKey],
            }))
          }
        >
          {sectionStatus[sectionKey] ? <Remove /> : <Add />}
        </IconButton>

        <Typography component="span" variant="subtitle2">
          {label}
        </Typography>
      </Box>

      {sectionStatus[sectionKey] && <Box>{children}</Box>}
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    gap: '12px',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    gap: '8px',
    padding: '4px',
    display: 'flex',
    borderRadius: '4px',
    alignItems: 'center',
    backgroundColor: grey['A100'],
  },
  content: {},
});
